module.exports = __webpack_public_path__ + "media/images/logo-768-4275f7744b249317cead1b6967bea763.jpg";